import React, { useContext, useEffect, useState, useMemo } from "react"

const isNumeric = (str) => {
    if (typeof str != "string") return false
    return !isNaN(str) &&
        !isNaN(parseFloat(str))
}

const NumberPad = ({
    amount,
    updateAmount,
    allowFloat = false,
}) => {
    const btnPressed = (btnValue) => {
        if (btnValue == '<') {
            updateAmount(amount.toString().substr(0, amount.toString().length - 1))
        } else {
            const newValue = amount.toString() + btnValue

            if (!isNumeric(newValue) || (amount.toString().includes('.') && btnValue == '.')) {
                return
            }

            updateAmount(newValue)
        }
    }

    const buttons = useMemo(() => {
        const buttons = [
            { value: 1, type: 'btn' },
            { value: 2, type: 'btn' },
            { value: 3, type: 'btn' },
            { value: 4, type: 'btn' },
            { value: 5, type: 'btn' },
            { value: 6, type: 'btn' },
            { value: 7, type: 'btn' },
            { value: 8, type: 'btn' },
            { value: 9, type: 'btn' },
            { value: 0, type: 'btn' },
        ]

        if (allowFloat) {
            buttons.push({ value: '.', type: 'btn' })
        } else {
            buttons.push({ type: 'spacer' })
        }

        buttons.push({ value: '<', type: 'btn' })

        return buttons
    }, [allowFloat])

    return (
        <div className=" npad_padHolder ">
            { buttons.map((button, index) => {
                if (button.type == 'spacer') {
                    return (
                        <div key={ index } className=" npad_spacer "></div>
                    )
                } else {
                    return (
                        <a
                            key={ index }
                            onClick={ () => btnPressed(button.value) }
                            className=" npad_btn "
                        >
                            { button.value }
                        </a>
                    )
                }
            }) }
        </div>
    )
}

export default NumberPad